import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import EPWeekSetting from '../EPWeekSetting';
import { useLocation, useNavigate } from 'react-router-dom';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FlagIcon from '@mui/icons-material/Flag';
import MonitorSetting from './MonitorSetting';
import { useSelector } from 'react-redux';
import { getProfile } from '../../../reducer/profileSlice';



// const config = {
//     patient: {
//         province: "1,11,51,151,400",
//         amphur: "1,6,21,51,100",
//         tambon: "1,2,6,11,20"
//     }
// }

// const setting = {
//     inum: "xxxxxx",
//     setting: [{
//         disease: "",
//         data: {
//             area: "morbidity",
//             patient: false,
//             spotmap: false,
//             cluster: false,
//             co: false,
//             nco: false
//         },
//         arealevel: "province",
//         areaselected: {
//             level: 1,
//             value: "thailand"
//         }
//     }]
// }
// console.log(process.env.REACT_APP_ENABLE_FULL_FUNCTION === "false");
// console.log(process.env.REACT_APP_ENABLE_FULL_FUNCTION === false);
// let menuList = [{
//     path: "dashboard",
//     icon: <DashboardIcon />,
//     text: 'Dashboard'
// }, {
//     path: "monitor",
//     icon: <DesktopMacIcon />,
//     text: 'Monitor'
// }, {
//     path: "myeoc",
//     icon: <FlagIcon />,
//     text: 'My EOC'
// }]
let menuList = process.env.REACT_APP_ENABLE_FULL_FUNCTION === "true" ? [{
    path: "dashboard",
    icon: <DashboardIcon />,
    text: 'Dashboard'
}, {
    path: "monitor",
    icon: <DesktopMacIcon />,
    text: 'Monitor'
}, {
    path: "myeoc",
    icon: <FlagIcon />,
    text: 'My EOC'
}] : [{
    path: "monitor",
    icon: <DesktopMacIcon />,
    text: 'Monitor'
}]

function DengueSetting() {
    const navigate = useNavigate();
    // const [value, setValue] = React.useState('morbidity');
    const { pathname } = useLocation();
    let pathlink = pathname.replace("/", "");
    const profile = useSelector(getProfile);
    // console.log(pathlink);

    // const MyFormControlLabel = styled(FormControlLabel)(() => ({
    //     '& .MuiFormControlLabel-label': {
    //     }
    // }));

    // const handleSelectedRadio = (event) => {
    //     if (event.target.value === value) {
    //         setValue("");
    //     } else {
    //         setValue(event.target.value);
    //     }
    // }

    return (
        <>
            <div style={{
                position: 'relative',
                width: '100%',
                height: 'calc(100vh - 70px)',
                overflow: 'auto'
            }}>
                {/* <Divider /> */}
                <div className='py-4'>
                    <EPWeekSetting skipMode />
                </div>
                <nav aria-label="secondary mailbox folders">
                    <List>
                        {
                            menuList.map((data) => {
                                if (data.path === 'myeoc' && ["05", "06"].includes(profile?.org_level)) {
                                    return null;
                                }

                                return (
                                    <ListItem key={data.path} disablePadding>
                                        <ListItemButton onClick={() => {
                                            navigate(data.path);
                                        }}>
                                            <ListItemIcon sx={{
                                                color: pathlink === data.path ? '#cd6c4a' : 'gray'
                                            }}>
                                                {data.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={data.text} sx={{
                                                color: pathlink === data.path ? '#cd6c4a' : 'gray'
                                            }} />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })
                        }
                    </List>
                </nav>
                <Divider className='m-4' />
                {
                    pathlink === 'monitor' ? <>
                        <MonitorSetting />
                    </> : <></>
                }
                {/* <Typography variant="subtitle1" sx={{
                    color: 'black',
                    textAlign: 'left',
                    marginTop: '10px'
                }}>
                    การแสดงผล
                </Typography> */}
                {/* <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={value}
                    name="radio-buttons-group"
                >
                    <MyFormControlLabel value="morbidity" control={<Radio onClick={handleSelectedRadio}/>} label="อัตราป่วย" />
                    <MorbidityRate checked={value === 'morbidity'} />
                    
                    <MyFormControlLabel value="compare" control={<Radio onClick={handleSelectedRadio}/>} label="จำนวนผู้ป่วยเทียบ" />
                    <PatientCompare checked={value === "compare"}/>
                    
                </RadioGroup>
                <Divider/>
                <FormGroup>
                    <PatientSetting config={config.patient} />
                    <SpotMapSetting />
                    <ClusterSetting />
                    <HISetting />
                    <CISetting />
                </FormGroup> */}
                {/* <RenderTypeSetting /> */}
                {/* <AreaSelectedSetting /> */}
                {/* <AreaLevelSetting /> */}
            </div>
        </>
    )
}

export default DengueSetting;